"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.components = void 0;
const data_display_1 = require("./components/data-display");
const mui_chip_theme_options_1 = require("./components/data-display/mui-chip-theme-options");
const mui_skeleton_theme_options_1 = require("./components/feedback/mui-skeleton-theme-options");
const inputs_1 = require("./components/inputs");
const mui_select_theme_options_1 = require("./components/inputs/mui-select-theme-options");
const navigation_1 = require("./components/navigation");
const utils_1 = require("./components/utils");
exports.components = {
    /** ===== INPUTS ===== */
    MuiButton: inputs_1.MuiButtonThemeOptions,
    MuiOutlinedInput: inputs_1.MuiOutlinedInputThemeOptions,
    MuiInputLabel: inputs_1.MuiInputLabelThemeOptions,
    MuiSwitch: inputs_1.MuiSwitchThemeOptions,
    MuiRadio: inputs_1.MuiRadioThemeOptions,
    MuiCheckbox: inputs_1.MuiCheckboxThemeOptions,
    MuiSelect: mui_select_theme_options_1.MuiSelectThemeOptions,
    MuiFormHelperText: inputs_1.MuiFormHelperTextThemeOptions,
    /** ===== DATA DISPLAY ===== */
    MuiChip: mui_chip_theme_options_1.MuiChipThemeOptions,
    MuiIconButton: data_display_1.MuiIconButtonThemeOptions,
    MuiTooltip: data_display_1.MuiTooltipThemeOptions,
    MuiListItemButton: data_display_1.MuiListItemButtonThemeOptions,
    MuiListItemText: data_display_1.MuiListItemTextThemeOptions,
    MuiListItemSecondaryAction: data_display_1.MuiListItemSecondaryActionThemeOptions,
    /** ===== FEEDBACK ===== */
    MuiSkeleton: mui_skeleton_theme_options_1.MuiSkeletonThemeOptions,
    /** ===== SURFACES ===== */
    /** ===== NAVIGATION ===== */
    MuiDrawer: navigation_1.MuiDrawerThemeOptions,
    MuiMenu: navigation_1.MuiMenuThemeOptions,
    MuiMenuItem: navigation_1.MuiMenuItemThemeOptions,
    /** ===== LAYOUT ===== */
    /** ===== UTILS ===== */
    MuiCssBaseline: utils_1.MuiCssBaselineThemeOptions,
    /** ===== DATA GRID ===== */
};
